export interface SubmissionAttempt<T> {
  idempotencyKey: string;
  payload: T;
}

export interface SubmissionLock<T> {
  begin: (payload: T) => SubmissionAttempt<T> | null;
  release: () => void;
  reset: () => void;
  isLocked: () => boolean;
}

function payloadsMatch<T>(left: T, right: T): boolean {
  return JSON.stringify(left) === JSON.stringify(right);
}

export function createSubmissionLock<T>(
  createKey: () => string = () => crypto.randomUUID()
): SubmissionLock<T> {
  let locked = false;
  let attempt: SubmissionAttempt<T> | null = null;

  return {
    begin(payload) {
      if (locked) return null;
      locked = true;
      if (!attempt || !payloadsMatch(attempt.payload, payload)) {
        attempt = {
          idempotencyKey: createKey(),
          payload: structuredClone(payload),
        };
      }
      return attempt;
    },
    release() {
      locked = false;
    },
    reset() {
      locked = false;
      attempt = null;
    },
    isLocked() {
      return locked;
    },
  };
}
